import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from 'react-helmet-async'; // Import Helmet
import clsx from "clsx";
import styles from "styles/App.module.scss";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify styles

// PAGES
import Shop from "pages/Shop";
import Detail from "pages/Detail";
import Category from "pages/Category";
import About from "pages/About";
import Gallery from "pages/Gallery";

// COMPONENTS
import Header from "components/Header";
import BasketSidebar from "components/BasketSidebar";
import Footer from "components/Footer";
import MobileBottomNav from "components/MobileBottomNav";

// HOOKS
import useMobileDetect from "hooks/useMobileDetect";

// CONTEXT
import BasketContextProvider from "context/BasketContext";

const App = () => {
  const device = useMobileDetect();

  return (
      <Router>
        <BasketContextProvider>
          <Helmet>
            <title>Muscle Factory - Your Fitness Destination</title>
            <meta name="description" content="Bienvenido a Muscle Factory: tu destino definitivo para la condición física, la fuerza y el bienestar." />
          </Helmet>

          <ToastContainer
              position="bottom-right"
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
          />

          <div
              className={clsx(
                  device.type === "mobile" ? styles.paddingForMobile : null,
                  styles.container
              )}
          >
            <Header />
            <main className={styles.main}>
              <Routes>
                <Route path="/" element={<Shop />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/about" element={<About />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/product/:slug" element={<Detail />} />
                <Route path="/category/:slug" element={<Category />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <BasketSidebar />
          {device.type === "mobile" && <MobileBottomNav />}
        </BasketContextProvider>
      </Router>
  );
};

export default App;
